import amplitude from 'amplitude-js';
class AmplitudeTracker {
    constructor(config) {
        this.name = 'amplitude';
        this.trackActivity = (params) => {
            this.query({ ...params });
        };
        this.trackGoal = (params) => {
            this.query({ ...params });
        };
        this.setUser = (user) => {
            const { email } = user;
            amplitude.getInstance().setUserId(email);
            amplitude.getInstance().setUserProperties({ isLoggedIn: true });
        };
        this.normalizeType = (type) => type.toLowerCase();
        this.normalizeHref = (href) => (/^(\/|#)/.exec(href) ? href : `/${href}`);
        this.query = (queryParams) => {
            const { title, href: hrefProp, type: typeProp, value: trackingValue = '' } = queryParams;
            const href = this.normalizeHref(hrefProp);
            const type = this.normalizeType(typeProp);
            const value = trackingValue || '';
            amplitude.getInstance().logEvent(title, { href, type, value });
        };
        const { options: { deviceId } } = amplitude.getInstance();
        const { clientToken, user } = config;
        this.name = 'amplitude';
        amplitude.getInstance().init(clientToken, undefined, {
            deviceId,
            includeUtm: true,
            sessionTimeout: 15 * 60 * 1000
        });
        amplitude.getInstance().setUserProperties({ isLoggedIn: false });
        if (user?.email) {
            this.setUser(user);
        }
    }
}
export default AmplitudeTracker;
//# sourceMappingURL=amplitude.js.map